var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnClose24 = function SvgLightIcnClose24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.423 6.13.707-.707 12.21 12.21-.707.707z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.633 5.423.707.707L6.13 18.34l-.707-.707z"
  })));
};
export default SvgLightIcnClose24;